module.exports = __webpack_public_path__ + "img/78.5.COD.d0a25aed.png";